var exports = {
  "x": "NagbarButton.module__button___NXhMSk",
};

module.exports = exports;
